<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="3" v-if="order.orderType == 1"><el-button type="primary"
                    @click="saveOrderOutLog(order.id)">手动离场</el-button></el-col>
            <el-col :span="3" v-if="order.orderType == 1"><el-button type="primary"
                    @click="repeatPlate(order.id)">重新取证</el-button></el-col>
            <!-- <el-col :span="6"><el-button type="primary">修正入场时间</el-button></el-col> -->
            <!-- <el-col :span="6"><el-button type="primary">修正离场时间</el-button></el-col> -->
            <!-- <el-col :span="6"><el-button type="primary">重新算费</el-button></el-col> -->
            <el-col :span="3" v-if="order.orderType == 1"><el-button type="primary"
                    @click="showUpdateParkingNum(order)">修改费率</el-button></el-col>
            <el-col :span="3" v-if="order.orderType == 1"><el-button type="primary"
                    @click="showUpdateOrderIn(order)">修改车牌</el-button></el-col>
            <el-col :span="3">
                <el-button type="primary" :disabled="['1', '2', '3', '4', '100'].indexOf(order.status) > -1"
                    @click="createErrorOrder(order)">
                    生成异常记录</el-button>
            </el-col>

        </el-row>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="780px" class="children-dialog" append-to-body>
            <el-table :data='payDetailList' v-if="dialogType == 'detail'">
                <el-table-column prop="payId" label="第三方支付单号"></el-table-column>
                <el-table-column prop="payAmount" label="支付金额"></el-table-column>
                <el-table-column prop="couponMoney" label="优惠金额"></el-table-column>
                <el-table-column prop="payType" label="支付途径">
                    <template slot-scope="scope">
                        {{ scope.row.payType | payType }}
                    </template>
                </el-table-column>
                <el-table-column prop="payTime" label="支付时间"></el-table-column>
            </el-table>
            <el-form label-width="90px" inline v-if="dialogType == 'audit'">
                <el-form-item label="车牌颜色">
                    <el-select v-model="dialogData.plateColor" placeholder="请选择" filterable>
                        <el-option label="蓝色" value="1"></el-option>
                        <el-option label="黄色" value="2"></el-option>
                        <el-option label="白色" value="3"></el-option>
                        <el-option label="黑色" value="4"></el-option>
                        <el-option label="绿色" value="5"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="车牌号">
                    <el-input v-model="dialogData.plate"></el-input>
                </el-form-item>
            </el-form>
            <el-form label-width="90px" inline v-if="dialogType == 'parkingNum'">
                <el-form-item label="费率">
                    <el-select v-model="dialogData.parkingNum" placeholder="请选择" filterable>
                        <el-option label="单车位收费" value="1"></el-option>
                        <el-option label="双车位收费" value="2"></el-option>
                        <el-option label="三车位收费" value="3"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">关 闭</el-button>
                <el-button type="primary" @click="updateOrderIn" v-if="dialogType == 'audit'">确 定</el-button>
                <el-button type="primary" @click="updateParkingNum" v-if="dialogType == 'parkingNum'">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'ParkingOrderOperat',
    props: {
        // 接收订单数据对象
        order: {
            type: Object,
            required: true,
            validator(value) {
                // 可选：添加简单校验
                return value && typeof value === 'object';
            }
        }
    },
    data() {
        return {
            dialogVisible: false,
            dialogTitle: "",
            dialogType: "",
            dialogData: {
                id: "",
                plateColor: "",
                plate: "",
            },
        }
    },
    methods: {
        saveOrderOutLog(id) {
            this.$prompt("请输入手动离场备注", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
            })
                .then(({ value }) => {
                    this.$http.post(
                        this.$api.saveOrderOutLog,
                        { id, remark: value },
                        (res) => {
                            this.$message.success("车辆手动离场成功！");
                            this.$refs.table.reloadData();
                        }
                    );
                })
                .catch(() => { });
        },
        repeatPlate(id) {
            this.$confirm('是否将该订单重新取证?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.updateOrderToUnHaveEvidenceOrder(id)
            }).catch(() => {
            });
        },

        updateOrderToUnHaveEvidenceOrder(id) {
            this.$http.get(
                this.$api.updateOrderToUnHaveEvidenceOrder,
                { id },
                (res) => {
                    this.$message.success("状态修改成功！");
                    // this.$refs.table.reloadData();
                }
            );
        },

        showUpdateOrderIn(item) {
            let { id, plateColor, plate } = item;
            this.dialogVisible = true;
            this.dialogType = "audit";
            this.dialogTitle = "审核订单车牌号";
            this.dialogData = { id, plateColor, plate };
        },
        updateOrderIn() {
            this.$http.post(this.$api.updateOrderIn, this.dialogData, (res) => {
                this.dialogVisible = false;
                this.$message.success("车牌审核成功！");
                this.$refs.table.reloadData();
            });
        },
        showUpdateParkingNum(item) {
            let { id, parkingNum } = item;
            this.dialogVisible = true;
            this.dialogType = "parkingNum";
            this.dialogTitle = "修改收费费率";
            this.dialogData = { id, parkingNum };
        },
        updateParkingNum() {
            this.$http.post(this.$api.updateParkingNum, this.dialogData, (res) => {
                this.dialogVisible = false;
                this.$message.success("修改费率成功");
                this.$emit('refresh-data', '子组件传递的数据');
            });
        },
        createErrorOrder(item) {
            this.$root.$emit("showWorkorderDialog", {
                type: "order",
                data: item,
                callback: () => {
                    this.$refs.table.reloadData();
                },
            });
        },
    }
}
</script>
<style scoped>
.el-col {
    margin-bottom: 20px;
}
</style>